// In-memory access-token store.
//
// Access-токен хранится ТОЛЬКО в памяти JS-процесса (не в localStorage),
// чтобы XSS не мог украсть его через `localStorage.getItem("access_token")`.
// Теряется при reload вкладки — это нормально: на бутстрапе вызывается
// /login/refresh/, который восстанавливает access из refresh-токена.
//
// См. audit #2.

let _accessToken = null;

export const sessionStore = {
  get accessToken() {
    return _accessToken;
  },
  setAccessToken(token) {
    _accessToken = token || null;
  },
  clearAccessToken() {
    _accessToken = null;
  },
};
